import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
  attentionGetPage,
} from '@/api/onlinerateanalysisresultserv'

export default {
  state: {
    state_OnlineRateAnalysisResult_GetPageResult: null,
    state_OnlineRateAnalysisResult_GetDetailResult: null,
    state_OnlineRateAnalysisResult_GetClientPageResult: null,
    state_OnlineRateAnalysisResult_ExportExcelResult: null,
    state_OnlineRateAnalysisResult_AttentionGetPageResult: null,
  },
  mutations: {
    SET_ONLINERATEANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_OnlineRateAnalysisResult_GetPageResult = rst;
    },
    SET_ONLINERATEANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_OnlineRateAnalysisResult_GetDetailResult = rst;
    },
    SET_ONLINERATEANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_OnlineRateAnalysisResult_GetClientPageResult = rst;
    },
    SET_ONLINERATEANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_OnlineRateAnalysisResult_ExportExcelResult = rst;
    },
    SET_ONLINERATEANALYSISRESULT_ATTENTIONGETPAGE_RESULT: (state, rst) => {
      state.state_OnlineRateAnalysisResult_AttentionGetPageResult = rst;
    },
  },
  actions: {
    OnlineRateAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ONLINERATEANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ONLINERATEANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OnlineRateAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ONLINERATEANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ONLINERATEANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OnlineRateAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ONLINERATEANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ONLINERATEANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OnlineRateAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ONLINERATEANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ONLINERATEANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OnlineRateAnalysisResultServ_AttentionGetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        attentionGetPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ONLINERATEANALYSISRESULT_ATTENTIONGETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ONLINERATEANALYSISRESULT_ATTENTIONGETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OnlineRateAnalysisResult_GetPageResult: state => {
      return state.state_OnlineRateAnalysisResult_GetPageResult;
    },
    get_OnlineRateAnalysisResult_GetDetailResult: state => {
      return state.state_OnlineRateAnalysisResult_GetDetailResult;
    },
    get_OnlineRateAnalysisResult_GetClientPageResult: state => {
      return state.state_OnlineRateAnalysisResult_GetClientPageResult;
    },
    get_OnlineRateAnalysisResult_ExportExcelResult: state => {
      return state.state_OnlineRateAnalysisResult_ExportExcelResult;
    },
    get_OnlineRateAnalysisResult_AttentionGetPageResult: state => {
      return state.state_OnlineRateAnalysisResult_AttentionGetPageResult;
    },
  }
}